import { getTextAlign } from '@applyft-web/ui-components';
import styled, { css } from 'styled-components';

export const CheckboxWrapper = styled.label<{
  $error: boolean;
  $consent: boolean;
}>`
  ${({ theme, $error, $consent }) => css`
    padding: 2px 0;
    ${`padding-${getTextAlign(theme.isRtl)}`}: 32px;

    margin-top: 16px;
    display: flex;
    flex-direction: ${theme.isRtl ? 'row-reverse' : 'row'};
    align-items: center;
    position: relative;
    font-size: 13px;
    line-height: 17px;
    text-align: ${theme.isRtl ? 'right' : 'left'};

    &::before,
    &::after {
      content: '';
      position: absolute;
      display: block;
    }

    &::before {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid ${$error ? '#EF5C5C' : '#C8C8C8'};
      background-color: transparent;
      transition:
        border-color 0.3s,
        background-color 0.3s;
      box-sizing: border-box;
      top: ${$consent ? '5px' : 'calc(50% - 10px)'};
      ${getTextAlign(theme.isRtl)}: 0;
    }

    .check-icon {
      width: 10px;
      height: 10px;
      position: absolute;
      top: ${$consent ? '15px' : '50%'};
      ${getTextAlign(theme.isRtl)}: 10px;

      transform: translate(calc(50% * ${theme.isRtl ? 1 : -1}), -50%);

      path {
        fill: #fff;
      }
    }

    &:has(.checkbox:checked) {
      &::before {
        border-color: ${theme.colors.primary};
        background-color: ${theme.colors.primary};
      }
    }

    @media screen and (min-width: ${theme?.desktopMinWidth}px) {
      font-size: 14px;
      line-height: 19px;
    }
  `};
`;

export const Checkbox = styled.input`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: -9999px;
`;
